import { Card, Modal } from '@mui/material';
import { ReactNode } from 'react';

type OrgSwitcherModalProps = {
  children: ReactNode;
  open: boolean;
  onClose: () => void;
};

export default function OrgSwitcherModal({ children, open, onClose }: OrgSwitcherModalProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <Card
        sx={{
          width: 700,
          maxWidth: '95vw',
          maxHeight: '85vh',
          overflow: 'auto',
          position: 'absolute',
          left: '50%',
          top: '10%',
          transform: 'translate(-50%, 0)',
          borderRadius: 2,
        }}
      >
        {children}
      </Card>
    </Modal>
  );
}
